var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        width: "1280px",
        top: "3vh",
        "close-on-click-modal": false,
        "custom-class": "sk-dialog sk-dialog--xl tdi-excel-wizard-dialog",
        "before-close": _vm.handleBeforeClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        closed: _vm.resetState,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "wizard-dialog-title",
          attrs: { slot: "title" },
          slot: "title",
        },
        [
          _c("div", { staticClass: "wizard-title-main" }, [
            _c("i", {
              staticClass: "el-icon-upload",
              staticStyle: { color: "#2563eb", "margin-right": "8px" },
            }),
            _c("span", [
              _vm._v("Khởi Tạo Phiếu Thu Học Sinh Từ File Excel (Lớp / Nhóm)"),
            ]),
          ]),
          _c("span", { staticClass: "wizard-title-sub" }, [
            _vm._v(
              "\n      Hướng dẫn từng bước tải file mẫu (2 sheets kèm danh mục khoản thu), cấu hình đợt thu, đối soát dữ liệu.\n    "
            ),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "wizard-steps-wrapper" },
        [
          _c(
            "el-steps",
            {
              attrs: {
                active: _vm.activeStep,
                "finish-status": "success",
                "align-center": "",
              },
            },
            [
              _c("el-step", {
                attrs: {
                  title: "Bước 1",
                  description: "Chọn học sinh & Tải file mẫu",
                  icon: "el-icon-download",
                },
              }),
              _c("el-step", {
                attrs: {
                  title: "Bước 2",
                  description: "Cấu hình & Tải file lên đối soát",
                  icon: "el-icon-upload2",
                },
              }),
              _c("el-step", {
                attrs: {
                  title: "Bước 3",
                  description: "Xem trước & Khởi tạo dữ liệu DB",
                  icon: "el-icon-view",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeStep === 0,
              expression: "activeStep === 0",
            },
          ],
          staticClass: "sk-dialog__content",
        },
        [
          _c("div", { staticClass: "sk-panel" }, [
            _c("div", { staticClass: "sk-panel-head" }, [
              _c("div", { staticClass: "sk-panel-icon" }, [
                _c("i", { staticClass: "el-icon-date" }),
              ]),
              _c("div", [
                _c("p", { staticClass: "sk-panel-title" }, [
                  _vm._v("1. Thông tin đợt thu & Danh sách học sinh"),
                ]),
                _c("p", { staticClass: "sk-panel-subtitle" }, [
                  _vm._v(
                    "Dữ liệu học sinh và các khoản thu đã khởi tạo được lấy trực tiếp từ màn hình chính"
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "wizard-filter-grid" }, [
              _c(
                "div",
                { staticClass: "filter-item" },
                [
                  _c("span", { staticClass: "filter-label" }, [
                    _vm._v("Phạm vi:"),
                  ]),
                  _c(
                    "el-tag",
                    {
                      staticStyle: { "font-weight": "600" },
                      attrs: { size: "small", type: "primary", effect: "dark" },
                    },
                    [
                      _c("i", {
                        class:
                          _vm.step1Filter.targetType === "GROUP"
                            ? "el-icon-s-custom"
                            : "el-icon-school",
                      }),
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.scopeName ||
                              _vm.currentClassName ||
                              (_vm.step1Filter.targetType === "GROUP"
                                ? "Theo nhóm"
                                : "Theo lớp")
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "filter-item" },
                [
                  _c("span", { staticClass: "filter-label" }, [
                    _vm._v("Tháng:"),
                  ]),
                  _c("el-date-picker", {
                    staticStyle: { width: "130px" },
                    attrs: {
                      type: "month",
                      format: "MM-yyyy",
                      "value-format": "M-yyyy",
                      placeholder: "Chọn tháng",
                      size: "small",
                      clearable: false,
                      disabled: "",
                    },
                    model: {
                      value: _vm.step1Filter.monthAndYear,
                      callback: function ($$v) {
                        _vm.$set(_vm.step1Filter, "monthAndYear", $$v)
                      },
                      expression: "step1Filter.monthAndYear",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "filter-item" },
                [
                  _c("span", { staticClass: "filter-label" }, [
                    _vm._v("Đợt thu:"),
                  ]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "110px" },
                      attrs: {
                        placeholder: "Chọn đợt",
                        size: "small",
                        disabled: "",
                      },
                      model: {
                        value: _vm.step1Filter.turn,
                        callback: function ($$v) {
                          _vm.$set(_vm.step1Filter, "turn", $$v)
                        },
                        expression: "step1Filter.turn",
                      },
                    },
                    _vm._l(20, function (t) {
                      return _c("el-option", {
                        key: t,
                        attrs: { value: t, label: `Đợt ${t}` },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "wizard-options-row" }, [
              _c(
                "div",
                { staticClass: "option-check-item" },
                [
                  _c("el-switch", {
                    attrs: { "active-color": "#10b981" },
                    model: {
                      value: _vm.step1Options.includeAttendance,
                      callback: function ($$v) {
                        _vm.$set(_vm.step1Options, "includeAttendance", $$v)
                      },
                      expression: "step1Options.includeAttendance",
                    },
                  }),
                  _c("span", { staticClass: "option-check-label" }, [
                    _c("strong", [_vm._v("Lấy dữ liệu điểm danh")]),
                  ]),
                  _vm.step1Options.includeAttendance
                    ? _c("el-date-picker", {
                        staticStyle: { width: "140px", "margin-left": "6px" },
                        attrs: {
                          type: "month",
                          format: "MM-yyyy",
                          "value-format": "M-yyyy",
                          placeholder: "Chọn tháng điểm danh",
                          size: "mini",
                          clearable: false,
                          "picker-options": _vm.attendancePickerOptions,
                        },
                        model: {
                          value: _vm.step1Options.attendanceMonth,
                          callback: function ($$v) {
                            _vm.$set(_vm.step1Options, "attendanceMonth", $$v)
                          },
                          expression: "step1Options.attendanceMonth",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "option-check-item" },
                [
                  _c("el-switch", {
                    attrs: { "active-color": "#10b981" },
                    model: {
                      value: _vm.step1Options.includePreviousDebt,
                      callback: function ($$v) {
                        _vm.$set(_vm.step1Options, "includePreviousDebt", $$v)
                      },
                      expression: "step1Options.includePreviousDebt",
                    },
                  }),
                  _c("span", { staticClass: "option-check-label" }, [
                    _c("strong", [
                      _vm._v("Lấy thiếu/thừa của phiếu thu trước"),
                    ]),
                  ]),
                ],
                1
              ),
            ]),
            _c(
              "div",
              {
                staticClass: "wizard-sub-section",
                staticStyle: { "margin-top": "12px" },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between",
                      "align-items": "center",
                      "margin-bottom": "8px",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          gap: "8px",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-weight": "600",
                              "font-size": "13px",
                              color: "#334155",
                            },
                          },
                          [
                            _vm._v(
                              "\n              Danh sách học sinh (Đã chọn: "
                            ),
                            _c(
                              "strong",
                              { staticStyle: { color: "#2563eb" } },
                              [_vm._v(_vm._s(_vm.selectedStudents.length))]
                            ),
                            _vm._v(
                              " / " +
                                _vm._s(_vm.studentList.length) +
                                ")\n            "
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              color: "#2563eb",
                              "font-weight": "600",
                              padding: "0 4px",
                            },
                            attrs: { size: "mini", type: "text" },
                            on: { click: _vm.selectAllStudents },
                          },
                          [
                            _c("i", { staticClass: "el-icon-check" }),
                            _vm._v(" Chọn tất cả\n            "),
                          ]
                        ),
                        _c("span", { staticStyle: { color: "#cbd5e1" } }, [
                          _vm._v("|"),
                        ]),
                        _c(
                          "el-button",
                          {
                            staticStyle: { color: "#64748b", padding: "0 4px" },
                            attrs: { size: "mini", type: "text" },
                            on: { click: _vm.clearStudentSelection },
                          },
                          [
                            _c("i", { staticClass: "el-icon-close" }),
                            _vm._v(" Bỏ chọn\n            "),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _c("el-input", {
                          staticStyle: { width: "250px" },
                          attrs: {
                            placeholder: "Tìm mã hoặc tên học sinh...",
                            size: "mini",
                            "prefix-icon": "el-icon-search",
                            clearable: "",
                          },
                          model: {
                            value: _vm.studentKeyword,
                            callback: function ($$v) {
                              _vm.studentKeyword = $$v
                            },
                            expression: "studentKeyword",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.studentLoading,
                        expression: "studentLoading",
                      },
                    ],
                    ref: "studentTable",
                    staticClass: "sk-table",
                    attrs: {
                      data: _vm.filteredStudents,
                      "row-key": _vm.getStudentRowKey,
                      border: "",
                      size: "mini",
                      height: "260",
                    },
                    on: {
                      "selection-change": _vm.handleStudentSelectionChange,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "selection",
                        "reserve-selection": true,
                        width: "45",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "STT",
                        type: "index",
                        width: "50",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "kidCode",
                        label: "Mã học sinh",
                        width: "120",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-weight": "600",
                                    color: "#1e293b",
                                  },
                                },
                                [_vm._v(_vm._s(row.studentCode || row.kidCode))]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "fullName",
                        label: "Họ và tên",
                        "min-width": "160",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(row.fullName || row.name)),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "birthday",
                        label: "Ngày sinh",
                        width: "110",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    row.birthday
                                      ? _vm.formatDate(row.birthday)
                                      : "—"
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "nickName",
                        label: "Biệt danh",
                        width: "110",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [_vm._v(_vm._s(row.nickName || "—"))]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "className",
                        label: "Lớp",
                        width: "130",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _vm._v(
                                _vm._s(
                                  row.className ||
                                    _vm.scopeName ||
                                    _vm.currentClassName
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Số khoản đã tạo",
                        width: "120",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    size: "mini",
                                    type: "success",
                                    effect: "plain",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        (row.invoiceDetails &&
                                          row.invoiceDetails.length) ||
                                          0
                                      ) +
                                      " khoản\n              "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "sk-panel", staticStyle: { "margin-top": "14px" } },
            [
              _c(
                "div",
                {
                  staticClass: "sk-panel-head",
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                    "align-items": "center",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        gap: "12px",
                      },
                    },
                    [
                      _c("div", { staticClass: "sk-panel-icon" }, [
                        _c("i", { staticClass: "el-icon-tickets" }),
                      ]),
                      _c("div", [
                        _c("p", { staticClass: "sk-panel-title" }, [
                          _vm._v("2. Danh mục các khoản thu"),
                        ]),
                        _c("p", { staticClass: "sk-panel-subtitle" }, [
                          _vm._v(
                            "Bao gồm " +
                              _vm._s(_vm.configuredFeeColumns.length) +
                              " khoản thu. Các khoản kế thừa từ màn chính không được xóa."
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        gap: "10px",
                        "align-items": "center",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-redesign-add-fee",
                          attrs: { size: "small", icon: "el-icon-circle-plus" },
                          on: { click: _vm.openAddCustomFeeDialog },
                        },
                        [_vm._v("\n            Thêm khoản thu mới\n          ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c("input", {
                ref: "templateCatalogFileInput",
                staticStyle: { display: "none" },
                attrs: { type: "file", accept: ".xlsx" },
                on: { change: _vm.handleTemplateCatalogUpload },
              }),
              !_vm.uploadedTemplateCatalogFile
                ? _c(
                    "div",
                    {
                      staticClass: "old-template-dropzone",
                      class: { "is-dragover": _vm.isTemplateCatalogDragOver },
                      on: {
                        dragover: function ($event) {
                          $event.preventDefault()
                          _vm.isTemplateCatalogDragOver = true
                        },
                        dragleave: function ($event) {
                          $event.preventDefault()
                          _vm.isTemplateCatalogDragOver = false
                        },
                        drop: function ($event) {
                          $event.preventDefault()
                          return _vm.handleTemplateCatalogDrop.apply(
                            null,
                            arguments
                          )
                        },
                        click: function ($event) {
                          return _vm.$refs.templateCatalogFileInput.click()
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "old-template-dropzone-inner" },
                        [
                          _c(
                            "div",
                            { staticClass: "old-template-dropzone-left" },
                            [
                              _c(
                                "div",
                                { staticClass: "old-template-dropzone-icon" },
                                [_c("i", { staticClass: "el-icon-upload" })]
                              ),
                              _c(
                                "div",
                                { staticClass: "old-template-dropzone-text" },
                                [
                                  _c("div", { staticClass: "main-text" }, [
                                    _c("strong", [
                                      _vm._v("Kéo thả file mẫu vào đây"),
                                    ]),
                                    _vm._v(" hoặc "),
                                    _c(
                                      "span",
                                      { staticClass: "highlight-browse" },
                                      [_vm._v("bấm để nạp file")]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "sub-text" }, [
                                    _vm._v(
                                      "\n                Lấy danh mục từ Sheet "
                                    ),
                                    _c("code", [_vm._v("Khoản Thu")]),
                                    _vm._v(" trong file Excel ("),
                                    _c("code", [_vm._v(".xlsx")]),
                                    _vm._v(")\n              "),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "btn-browse-old-template",
                              attrs: {
                                size: "small",
                                icon: "el-icon-folder-opened",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.$refs.templateCatalogFileInput.click()
                                },
                              },
                            },
                            [_vm._v("\n            Chọn file mẫu\n          ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticClass: "old-template-active-card",
                      class: { "is-dragover": _vm.isTemplateCatalogDragOver },
                      on: {
                        dragover: function ($event) {
                          $event.preventDefault()
                          _vm.isTemplateCatalogDragOver = true
                        },
                        dragleave: function ($event) {
                          $event.preventDefault()
                          _vm.isTemplateCatalogDragOver = false
                        },
                        drop: function ($event) {
                          $event.preventDefault()
                          return _vm.handleTemplateCatalogDrop.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "old-template-card-top" }, [
                        _c("div", { staticClass: "old-template-file-info" }, [
                          _c(
                            "div",
                            { staticClass: "old-template-file-badge" },
                            [
                              _c("i", {
                                staticClass: "el-icon-document-checked",
                              }),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "old-template-file-details" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "file-name",
                                  attrs: {
                                    title: _vm.uploadedTemplateCatalogFile.name,
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-document",
                                    staticStyle: {
                                      color: "#10b981",
                                      "margin-right": "4px",
                                    },
                                  }),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.uploadedTemplateCatalogFile.name
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _c("div", { staticClass: "file-meta" }, [
                                _c("span", { staticClass: "file-size" }, [
                                  _vm._v(
                                    _vm._s(
                                      (
                                        _vm.uploadedTemplateCatalogFile.size /
                                        1024
                                      ).toFixed(1)
                                    ) + " KB"
                                  ),
                                ]),
                                _c("span", { staticClass: "file-divider" }, [
                                  _vm._v("•"),
                                ]),
                                _c("span", { staticClass: "file-fee-count" }, [
                                  _vm._v("\n                  Đã trích xuất "),
                                  _c(
                                    "strong",
                                    { staticStyle: { color: "#059669" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.importedTemplateFees.length)
                                      ),
                                    ]
                                  ),
                                  _vm._v(" khoản thu\n                "),
                                ]),
                                _c("span", { staticClass: "file-divider" }, [
                                  _vm._v("•"),
                                ]),
                                _c("span", { staticClass: "file-drag-hint" }, [
                                  _vm._v(
                                    "(Kéo thả file khác vào đây để thay thế)"
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "old-template-actions" },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "btn-change-old-file",
                                attrs: {
                                  size: "mini",
                                  type: "primary",
                                  plain: "",
                                  icon: "el-icon-refresh",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.$refs.templateCatalogFileInput.click()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Đổi file khác\n            "
                                ),
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                staticClass: "btn-remove-old-file",
                                attrs: {
                                  size: "mini",
                                  type: "danger",
                                  plain: "",
                                  icon: "el-icon-delete",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.removeTemplateCatalogFile.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [_vm._v("\n              Gỡ file\n            ")]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "old-template-card-bottom" }, [
                        _c("span", { staticClass: "switch-title" }, [
                          _vm._v("Nguồn khoản thu đưa vào file mẫu:"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "switch-options" },
                          [
                            _c(
                              "el-checkbox",
                              {
                                on: { change: _vm.recomputeConfiguredFees },
                                model: {
                                  value: _vm.useSystemFees,
                                  callback: function ($$v) {
                                    _vm.useSystemFees = $$v
                                  },
                                  expression: "useSystemFees",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Khoản từ hệ thống (" +
                                    _vm._s(_vm.systemFeeColumns.length) +
                                    ")\n            "
                                ),
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                on: { change: _vm.recomputeConfiguredFees },
                                model: {
                                  value: _vm.useTemplateCatalogFees,
                                  callback: function ($$v) {
                                    _vm.useTemplateCatalogFees = $$v
                                  },
                                  expression: "useTemplateCatalogFees",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Khoản từ file mẫu (" +
                                    _vm._s(_vm.importedTemplateFees.length) +
                                    ")\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
              _c(
                "div",
                { staticClass: "template-download-wrapper" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-redesign-download-template",
                      attrs: {
                        size: "small",
                        icon: "el-icon-download",
                        loading: _vm.downloadingTemplate,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleDownloadTemplate()
                        },
                      },
                    },
                    [_vm._v("\n          Tải file mẫu Excel\n        ")]
                  ),
                  _c("span", { staticClass: "template-download-hint" }, [
                    _c("i", {
                      staticClass: "el-icon-info",
                      staticStyle: { color: "#3b82f6" },
                    }),
                    _vm._v(
                      "\n          File mẫu gồm 2 Sheets, mỗi khoản có 5 cột dữ liệu. Mã và tên lấy từ Sheet Khoản Thu.\n        "
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "sk-note sk-note--warning",
                  staticStyle: { "margin-bottom": "10px" },
                },
                [
                  _c("i", { staticClass: "el-icon-info" }),
                  _c("span", [
                    _vm._v(
                      "Ghi chú: Toàn bộ thông tin các khoản mà học sinh đã được khởi tạo từ trước (Số lượng, Đơn giá, Giảm giá, Thành tiền) sẽ được tự động điền vào file Excel. File Excel khi tải lên ở Bước 2 bắt buộc phải có tối thiểu đầy đủ các khoản thu này."
                    ),
                  ]),
                ]
              ),
              _c("div", { staticClass: "fee-cards-container" }, [
                _c(
                  "div",
                  { staticClass: "fee-cards-grid" },
                  _vm._l(_vm.configuredFeeColumns, function (fee, idx) {
                    return _c(
                      "div",
                      {
                        key: idx,
                        class: [
                          "fee-card-box",
                          fee.isCustom
                            ? "fee-card-box--custom"
                            : "fee-card-box--system",
                        ],
                      },
                      [
                        _c("div", { staticClass: "fee-card-top" }, [
                          _c("div", { staticClass: "fee-card-main-meta" }, [
                            _c(
                              "div",
                              {
                                class: [
                                  "fee-card-avatar",
                                  fee.isCustom
                                    ? "fee-card-avatar--custom"
                                    : "fee-card-avatar--system",
                                ],
                              },
                              [
                                _c("i", {
                                  class: fee.isCustom
                                    ? "el-icon-edit-outline"
                                    : "el-icon-coin",
                                }),
                              ]
                            ),
                            _c("div", { staticClass: "fee-card-heading" }, [
                              _c("span", { staticClass: "fee-card-index" }, [
                                _vm._v("Khoản " + _vm._s(idx + 1)),
                              ]),
                              _c(
                                "h4",
                                {
                                  staticClass: "fee-card-title",
                                  attrs: { title: fee.name || fee.revenueName },
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(fee.name || fee.revenueName) +
                                      "\n                  "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "fee-card-badge-wrap" },
                            [
                              !fee.isCustom
                                ? _c(
                                    "el-tag",
                                    {
                                      staticClass: "fee-source-pill",
                                      attrs: {
                                        size: "small",
                                        type:
                                          fee.source === "Cấu hình lớp"
                                            ? "primary"
                                            : fee.source ===
                                              "Phiếu thu đã phát hành"
                                            ? "success"
                                            : "info",
                                        effect: "dark",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        class:
                                          fee.source ===
                                          "Phiếu thu đã phát hành"
                                            ? "el-icon-document-checked"
                                            : "el-icon-lock",
                                      }),
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(fee.source || "Hệ thống") +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "fee-custom-actions" },
                                    [
                                      _c(
                                        "el-tag",
                                        {
                                          staticClass: "fee-source-pill",
                                          attrs: {
                                            size: "small",
                                            type:
                                              fee.source === "Từ file mẫu"
                                                ? "warning"
                                                : "success",
                                            effect: "dark",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            class:
                                              fee.source === "Từ file mẫu"
                                                ? "el-icon-document"
                                                : "el-icon-circle-plus-outline",
                                          }),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(fee.source || "Tự thêm") +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                      _c("el-button", {
                                        staticClass: "fee-delete-btn",
                                        attrs: {
                                          type: "danger",
                                          size: "mini",
                                          icon: "el-icon-delete",
                                          circle: "",
                                          title:
                                            fee.source === "Từ file mẫu"
                                              ? "Xóa khoản thu từ file mẫu này"
                                              : "Xóa khoản thu tự thêm này",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.removeConfiguredFee(idx)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          ),
                        ]),
                        _c("div", { staticClass: "fee-card-info-grid" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "fee-info-block fee-info-block--code",
                            },
                            [
                              _c("span", { staticClass: "info-block-label" }, [
                                _vm._v("MÃ KHOẢN (EXCEL)"),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "info-block-value-code",
                                  attrs: {
                                    title: fee.revenueCode || "Chưa gán mã",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-document",
                                    staticStyle: {
                                      "margin-right": "4px",
                                      color: "#3b82f6",
                                    },
                                  }),
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(fee.revenueCode || "—") +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "fee-info-block fee-info-block--unit",
                            },
                            [
                              _c("span", { staticClass: "info-block-label" }, [
                                _vm._v("ĐƠN VỊ TÍNH"),
                              ]),
                              _c(
                                "div",
                                { staticClass: "info-block-value-unit" },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(fee.unit || "Tháng") +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "fee-card-price-hero" }, [
                          _c("span", { staticClass: "price-hero-label" }, [
                            _vm._v("Đơn giá định mức:"),
                          ]),
                          _c("div", { staticClass: "price-hero-figure" }, [
                            _c("span", { staticClass: "price-number" }, [
                              _vm._v(_vm._s(_vm.formatMoney(fee.price))),
                            ]),
                            _c("span", { staticClass: "price-currency" }, [
                              _vm._v("VNĐ"),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "fee-card-bottom" }, [
                          _c("span", { staticClass: "bottom-tag" }, [
                            _c("i", {
                              staticClass: "el-icon-circle-check",
                              staticStyle: {
                                color: "#10b981",
                                "margin-right": "4px",
                              },
                            }),
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  fee.isCustom
                                    ? fee.source === "Từ file mẫu"
                                      ? "Khoản nạp từ file mẫu"
                                      : "Khoản tự thêm trong file mẫu"
                                    : "Được bảo lưu từ cấu hình học phí"
                                ) +
                                "\n              "
                            ),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
                _vm.configuredFeeColumns.length === 0
                  ? _c("div", { staticClass: "fee-cards-empty" }, [
                      _c("i", { staticClass: "el-icon-warning-outline" }),
                      _c("p", [
                        _vm._v(
                          "Chưa có khoản thu nào trong danh mục. Bấm nút "
                        ),
                        _c("strong", [_vm._v('"Thêm khoản thu mới"')]),
                        _vm._v(" ở trên hoặc kiểm tra lại màn hình chính."),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ]
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeStep === 1,
              expression: "activeStep === 1",
            },
          ],
          staticClass: "sk-dialog__content",
        },
        [
          _c("div", { staticClass: "step2-layout-grid" }, [
            _c("div", { staticClass: "sk-panel step2-card" }, [
              _c("div", { staticClass: "sk-panel-head" }, [
                _c("div", { staticClass: "sk-panel-icon" }, [
                  _c("i", { staticClass: "el-icon-date" }),
                ]),
                _c("div", [
                  _c("p", { staticClass: "sk-panel-title" }, [
                    _vm._v("1. Thông tin đợt thu"),
                  ]),
                  _c("p", { staticClass: "sk-panel-subtitle" }, [
                    _vm._v("Thời gian hiệu lực và mô tả của đợt thu"),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "step2-card-body" }, [
                _c(
                  "div",
                  { staticClass: "period-info-tags" },
                  [
                    _c("span", { staticClass: "info-tag-label" }, [
                      _vm._v("Áp dụng:"),
                    ]),
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          size: "mini",
                          type: "primary",
                          effect: "plain",
                        },
                      },
                      [
                        _c("i", {
                          class:
                            _vm.step1Filter.targetType === "GROUP"
                              ? "el-icon-s-custom"
                              : "el-icon-school",
                        }),
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.scopeName ||
                                _vm.currentClassName ||
                                "Theo danh sách"
                            ) +
                            "\n            "
                        ),
                      ]
                    ),
                    _c(
                      "el-tag",
                      {
                        attrs: { size: "mini", type: "info", effect: "plain" },
                      },
                      [
                        _vm._v(
                          "\n              Đợt " +
                            _vm._s(_vm.invoicePeriod.turn || 1) +
                            "\n            "
                        ),
                      ]
                    ),
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          size: "mini",
                          type: "warning",
                          effect: "plain",
                        },
                      },
                      [
                        _vm._v(
                          "\n              Tháng " +
                            _vm._s(
                              _vm.invoicePeriod.monthAndYear ||
                                _vm.step1Filter.monthAndYear
                            ) +
                            "\n            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "form-control-item",
                    staticStyle: { "margin-bottom": "12px" },
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex", gap: "12px" } },
                      [
                        _c(
                          "div",
                          { staticStyle: { flex: "1" } },
                          [
                            _c("label", { staticClass: "control-label" }, [
                              _vm._v("Tháng thu:"),
                            ]),
                            _c("el-input", {
                              attrs: {
                                value:
                                  _vm.invoicePeriod.monthAndYear ||
                                  _vm.step1Filter.monthAndYear,
                                disabled: "",
                                size: "small",
                                "prefix-icon": "el-icon-date",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticStyle: { flex: "1" } },
                          [
                            _c("label", { staticClass: "control-label" }, [
                              _vm._v("Đợt thu "),
                              _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v("*"),
                              ]),
                              _vm._v(":"),
                            ]),
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "Chọn đợt thu",
                                  size: "small",
                                },
                                on: { change: _vm.handleStep2TurnChange },
                                model: {
                                  value: _vm.invoicePeriod.turn,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.invoicePeriod, "turn", $$v)
                                  },
                                  expression: "invoicePeriod.turn",
                                },
                              },
                              _vm._l(20, function (t) {
                                return _c("el-option", {
                                  key: t,
                                  attrs: { value: t, label: `Đợt ${t}` },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "form-control-item",
                    staticStyle: { "margin-bottom": "12px" },
                  },
                  [
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v("Khoảng thời gian hiệu lực "),
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("*"),
                      ]),
                      _vm._v(":"),
                    ]),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "daterange",
                        format: "dd-MM-yyyy",
                        "value-format": "yyyy-MM-dd",
                        "range-separator": "-",
                        "start-placeholder": "Từ ngày",
                        "end-placeholder": "Đến ngày",
                        size: "small",
                        "picker-options": _vm.pickerOptions,
                      },
                      model: {
                        value: _vm.invoicePeriod.dateRange,
                        callback: function ($$v) {
                          _vm.$set(_vm.invoicePeriod, "dateRange", $$v)
                        },
                        expression: "invoicePeriod.dateRange",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "form-control-item" },
                  [
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v("Mô tả đợt thu "),
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("*"),
                      ]),
                      _vm._v(":"),
                    ]),
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: 3,
                        placeholder: "Ví dụ: Phiếu thu học phí tháng 09/2026",
                        clearable: "",
                      },
                      model: {
                        value: _vm.invoicePeriod.description,
                        callback: function ($$v) {
                          _vm.$set(_vm.invoicePeriod, "description", $$v)
                        },
                        expression: "invoicePeriod.description",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _c("div", { staticClass: "sk-panel step2-card" }, [
              _c("div", { staticClass: "sk-panel-head" }, [
                _c(
                  "div",
                  { staticClass: "sk-panel-icon sk-panel-icon--success" },
                  [_c("i", { staticClass: "el-icon-upload2" })]
                ),
                _c("div", [
                  _c("p", { staticClass: "sk-panel-title" }, [
                    _vm._v("2. Tải file Excel đối soát"),
                  ]),
                  _c("p", { staticClass: "sk-panel-subtitle" }, [
                    _vm._v(
                      "File Excel .xlsx gồm 2 sheets (Danh Sách HS & Khoản Thu)"
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "step2-card-body" }, [
                _c("div", { staticClass: "upload-dropzone-container" }, [
                  _c("input", {
                    ref: "excelFileInput",
                    staticStyle: { display: "none" },
                    attrs: { type: "file", accept: ".xlsx" },
                    on: { change: _vm.handleFileUpload },
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "upload-dropzone",
                      class: { "is-dragover": _vm.isDragOver },
                      on: {
                        dragover: function ($event) {
                          $event.preventDefault()
                          _vm.isDragOver = true
                        },
                        dragleave: function ($event) {
                          $event.preventDefault()
                          _vm.isDragOver = false
                        },
                        drop: function ($event) {
                          $event.preventDefault()
                          return _vm.handleFileDrop.apply(null, arguments)
                        },
                        click: function ($event) {
                          return _vm.$refs.excelFileInput.click()
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-upload upload-dropzone-icon",
                      }),
                      _c("div", { staticClass: "upload-dropzone-text" }, [
                        _c("strong", [_vm._v("Bấm để chọn file Excel")]),
                        _vm._v(" hoặc kéo thả vào đây\n              "),
                      ]),
                      _c("div", { staticClass: "upload-dropzone-hint" }, [
                        _vm._v("\n                File mẫu "),
                        _c("code", [_vm._v(".xlsx")]),
                        _vm._v(
                          " với 2 Sheets (Danh Sách HS, Khoản Thu)\n              "
                        ),
                      ]),
                    ]
                  ),
                ]),
                _vm.uploadedFile
                  ? _c(
                      "div",
                      { staticClass: "uploaded-file-card" },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              gap: "10px",
                              overflow: "hidden",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-document",
                              staticStyle: {
                                "font-size": "22px",
                                color: "#10b981",
                                "flex-shrink": "0",
                              },
                            }),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  overflow: "hidden",
                                  "text-overflow": "ellipsis",
                                  "white-space": "nowrap",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-weight": "600",
                                      color: "#1e293b",
                                      "font-size": "13px",
                                    },
                                    attrs: { title: _vm.uploadedFile.name },
                                  },
                                  [_vm._v(_vm._s(_vm.uploadedFile.name))]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "11px",
                                      color: "#64748b",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          (
                                            _vm.uploadedFile.size / 1024
                                          ).toFixed(1)
                                        ) +
                                        " KB | " +
                                        _vm._s(_vm.parsedRows.length) +
                                        " dòng\n                  "
                                    ),
                                    _vm.hasFeeSheet
                                      ? _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "#2563eb",
                                              "margin-left": "4px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              '(Đã nhận diện Sheet "Khoản Thu")'
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "danger",
                              plain: "",
                              icon: "el-icon-delete",
                            },
                            on: { click: _vm.clearUploadedFile },
                          },
                          [_vm._v("\n              Gỡ file\n            ")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
          ]),
          _vm.hasValidated
            ? _c(
                "div",
                {
                  staticClass: "sk-panel",
                  staticStyle: { "margin-top": "14px" },
                },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c(
                      "div",
                      {
                        staticClass: "sk-panel-icon",
                        class:
                          _vm.errorList.length > 0
                            ? "sk-panel-icon--danger"
                            : "sk-panel-icon--success",
                      },
                      [
                        _c("i", {
                          class:
                            _vm.errorList.length > 0
                              ? "el-icon-warning"
                              : "el-icon-circle-check",
                        }),
                      ]
                    ),
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("3. Kết quả đối soát dữ liệu"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v(
                          "Tổng hợp kiểm tra cấu trúc file, mã học sinh, tên học sinh, danh mục khoản thu bắt buộc và mã phiếu thu"
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "kpi-cards-grid" }, [
                    _c("div", { staticClass: "kpi-card" }, [
                      _c("div", { staticClass: "kpi-title" }, [
                        _vm._v("Tổng số dòng"),
                      ]),
                      _c("div", { staticClass: "kpi-value" }, [
                        _vm._v(_vm._s(_vm.parsedRows.length)),
                      ]),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "kpi-card",
                        class: {
                          "kpi-card--success": _vm.errorList.length === 0,
                        },
                      },
                      [
                        _c("div", { staticClass: "kpi-title" }, [
                          _vm._v("Số dòng hợp lệ"),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "kpi-value",
                            staticStyle: { color: "#10b981" },
                          },
                          [_vm._v(_vm._s(_vm.validRowCount))]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "kpi-card",
                        class: { "kpi-card--danger": _vm.errorList.length > 0 },
                      },
                      [
                        _c("div", { staticClass: "kpi-title" }, [
                          _vm._v("Số lỗi phát hiện"),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "kpi-value",
                            style: {
                              color:
                                _vm.errorList.length > 0
                                  ? "#ef4444"
                                  : "#10b981",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.errorList.length) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "kpi-card" }, [
                      _c("div", { staticClass: "kpi-title" }, [
                        _vm._v("Số khoản thu phát hiện"),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "kpi-value",
                          staticStyle: { color: "#6366f1" },
                        },
                        [_vm._v(_vm._s(_vm.detectedFeeColumns.length))]
                      ),
                    ]),
                  ]),
                  _vm.checkingOnlinePayment
                    ? _c(
                        "div",
                        {
                          staticClass: "sk-note",
                          staticStyle: {
                            background: "#eff6ff",
                            "border-left": "4px solid #3b82f6",
                            color: "#1e40af",
                            "margin-bottom": "12px",
                            padding: "10px 14px",
                            "border-radius": "4px",
                            display: "flex",
                            "align-items": "center",
                            gap: "10px",
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-loading",
                            staticStyle: {
                              "font-size": "20px",
                              color: "#2563eb",
                            },
                          }),
                          _c("div", [
                            _c("strong", [
                              _vm._v(
                                "Đang kiểm tra trạng thái thanh toán trực tuyến từ hệ thống..."
                              ),
                            ]),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "12px",
                                  "margin-top": "2px",
                                },
                              },
                              [
                                _vm._v(
                                  "FE đối soát hợp lệ 100%. Đang kết nối Backend để kiểm tra xem có phiếu thu nào đã thanh toán online hay không."
                                ),
                              ]
                            ),
                          ]),
                        ]
                      )
                    : _vm.errorList.length > 0
                    ? _c("div", { staticClass: "sk-note sk-note--danger" }, [
                        _c("i", { staticClass: "el-icon-warning" }),
                        _c("div", [
                          _c("strong", [
                            _vm._v(
                              "File Excel phát hiện " +
                                _vm._s(_vm.errorList.length) +
                                " lỗi!"
                            ),
                          ]),
                          _c("div", [
                            _vm._v(
                              "Theo quy định, bạn phải sửa toàn bộ các lỗi dưới đây trên file Excel và tải lên lại cho đến khi hết lỗi mới được phép tiếp tục."
                            ),
                          ]),
                        ]),
                      ])
                    : _c("div", { staticClass: "sk-note sk-note--success" }, [
                        _c("i", { staticClass: "el-icon-circle-check" }),
                        _c("div", [
                          _c("strong", [
                            _vm._v(
                              "Dữ liệu file Excel hoàn toàn hợp lệ (100%)!"
                            ),
                          ]),
                          _c("div", [
                            _vm._v(
                              'Đã vượt qua đối soát và kiểm tra trạng thái thanh toán trực tuyến thành công. Bạn có thể bấm nút "Tiếp tục sang Bước 3".'
                            ),
                          ]),
                        ]),
                      ]),
                  _vm.errorList.length > 0
                    ? _c(
                        "div",
                        { staticStyle: { "margin-top": "10px" } },
                        [
                          _c(
                            "el-table",
                            {
                              staticClass: "sk-table",
                              attrs: {
                                data: _vm.errorList,
                                border: "",
                                size: "mini",
                                "max-height": "280",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "row",
                                  label: "Vị trí / Dòng",
                                  width: "120",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type:
                                                  typeof row.row === "number"
                                                    ? "danger"
                                                    : "warning",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    typeof row.row === "number"
                                                      ? `Dòng ${row.row}`
                                                      : row.row
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1629548818
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "studentCode",
                                  label: "Mã học sinh",
                                  width: "120",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-weight": "600",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(row.studentCode || "—")
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1840391807
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "studentName",
                                  label: "Họ và tên",
                                  width: "150",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _vm._v(
                                            _vm._s(row.studentName || "—")
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  213230885
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "field",
                                  label: "Tiêu chí đối soát",
                                  width: "160",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-weight": "600",
                                                color: "#b91c1c",
                                              },
                                            },
                                            [_vm._v(_vm._s(row.field))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3148504382
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "value",
                                  label: "Giá trị trên file",
                                  width: "140",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _c(
                                            "code",
                                            {
                                              staticStyle: { color: "#b91c1c" },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  row.value !== undefined &&
                                                    row.value !== null &&
                                                    row.value !== ""
                                                    ? row.value
                                                    : "(Trống)"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2098431069
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "expected",
                                  label: "Giá trị chuẩn hệ thống",
                                  width: "170",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          row.expected
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "#15803d",
                                                    "font-weight": "600",
                                                  },
                                                },
                                                [_vm._v(_vm._s(row.expected))]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "#94a3b8",
                                                  },
                                                },
                                                [_vm._v("—")]
                                              ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3401708291
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "message",
                                  label: "Mô tả lỗi & Hướng dẫn sửa",
                                  "min-width": "260",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: { color: "#dc2626" },
                                            },
                                            [_vm._v(_vm._s(row.message))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  835378933
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm.activeStep === 2
        ? _c("div", { staticClass: "sk-dialog__content" }, [
            _c(
              "div",
              { staticClass: "sk-panel" },
              [
                _c(
                  "div",
                  {
                    staticClass: "sk-panel-head",
                    staticStyle: { "margin-bottom": "12px" },
                  },
                  [
                    _c("div", { staticClass: "sk-panel-icon" }, [
                      _c("i", { staticClass: "el-icon-coin" }),
                    ]),
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Dữ liệu xem trước"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v(
                          "\n            Danh sách các phiếu thu sẽ được khởi tạo vào hệ thống cho "
                        ),
                        _c("strong", [
                          _vm._v(
                            "Tháng " +
                              _vm._s(
                                _vm.invoicePeriod.monthAndYear ||
                                  _vm.step1Filter.monthAndYear
                              ) +
                              " - Đợt " +
                              _vm._s(_vm.invoicePeriod.turn || 1)
                          ),
                        ]),
                        _vm._v(" (gồm chi tiết từng khoản thu)\n          "),
                      ]),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "kpi-cards-grid",
                    staticStyle: {
                      "margin-bottom": "12px",
                      "grid-template-columns": "repeat(5, 1fr)",
                    },
                  },
                  [
                    _c("div", { staticClass: "kpi-card" }, [
                      _c("div", { staticClass: "kpi-title" }, [
                        _vm._v("Tổng số phiếu thu"),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "kpi-value",
                          staticStyle: { color: "#2563eb" },
                        },
                        [_vm._v(_vm._s(_vm.generatedDbInvoices.length))]
                      ),
                    ]),
                    _c("div", { staticClass: "kpi-card" }, [
                      _c("div", { staticClass: "kpi-title" }, [
                        _vm._v("Tổng thiếu/thừa trước"),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "kpi-value",
                          style: {
                            color:
                              _vm.totalBeforeMoney < 0
                                ? "#dc2626"
                                : _vm.totalBeforeMoney > 0
                                ? "#16a34a"
                                : "#64748b",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.formatMoney(_vm.totalBeforeMoney)) +
                              " đ\n          "
                          ),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "kpi-card" }, [
                      _c("div", { staticClass: "kpi-title" }, [
                        _vm._v("Tổng tiền phải thu"),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "kpi-value",
                          staticStyle: { color: "#ea580c" },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.formatMoney(_vm.totalSumMoney)) + " đ"
                          ),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "kpi-card" }, [
                      _c("div", { staticClass: "kpi-title" }, [
                        _vm._v("Tổng tiền đã thu"),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "kpi-value",
                          staticStyle: { color: "#16a34a" },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.formatMoney(_vm.totalCollectedMoney)) +
                              " đ"
                          ),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "kpi-card" }, [
                      _c("div", { staticClass: "kpi-title" }, [
                        _vm._v("Tổng còn lại"),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "kpi-value",
                          style: {
                            color:
                              _vm.totalAfterMoney < 0 ? "#dc2626" : "#16a34a",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.formatMoney(_vm.totalAfterMoney)) + " đ"
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
                _c(
                  "el-table",
                  {
                    key: "preview_tbl_" + _vm.generatedDbInvoices.length,
                    ref: "previewTable",
                    staticClass: "sk-table",
                    attrs: {
                      data: _vm.generatedDbInvoices,
                      border: "",
                      size: "mini",
                      height: "350",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "STT",
                        type: "index",
                        width: "50",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "invoiceCode",
                        label: "Mã phiếu thu",
                        width: "160",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                row.invoiceCode
                                  ? _c(
                                      "el-tag",
                                      { attrs: { size: "mini", type: "info" } },
                                      [_vm._v(_vm._s(row.invoiceCode))]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "#94a3b8",
                                          "font-style": "italic",
                                          "font-size": "11px",
                                        },
                                      },
                                      [_vm._v("(Tạo mới)")]
                                    ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        52877083
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "studentCode",
                        label: "Mã HS",
                        width: "105",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "600" } },
                                  [_vm._v(_vm._s(row.studentCode))]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        193709099
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "fullName",
                        label: "Họ và tên",
                        "min-width": "150",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "className",
                        label: "Lớp",
                        width: "110",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "beforeMoney",
                        label: "Thiếu/thừa phiếu thu trước",
                        width: "170",
                        align: "right",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "span",
                                  {
                                    style: {
                                      color:
                                        row.beforeMoney < 0
                                          ? "#dc2626"
                                          : row.beforeMoney > 0
                                          ? "#16a34a"
                                          : "#64748b",
                                      fontWeight: "600",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.formatMoney(row.beforeMoney)
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1338111607
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "sumMoney",
                        label: "Phải thu",
                        width: "120",
                        align: "right",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-weight": "600",
                                      color: "#ea580c",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.formatMoney(row.sumMoney))
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3508924724
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "collectedMoney",
                        label: "Đã thu",
                        width: "110",
                        align: "right",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "span",
                                  { staticStyle: { color: "#16a34a" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatMoney(row.collectedMoney)
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        29314308
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "afterMoney",
                        label: "Còn lại",
                        width: "120",
                        align: "right",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "span",
                                  {
                                    style: {
                                      color:
                                        row.afterMoney < 0
                                          ? "#dc2626"
                                          : "#16a34a",
                                      fontWeight: "600",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.formatMoney(row.afterMoney)
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3884072904
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "note",
                        label: "Ghi chú duy nhất",
                        "min-width": "150",
                        "show-overflow-tooltip": "",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.customFeeDialogVisible,
            width: "580px",
            "append-to-body": "",
            "close-on-click-modal": false,
            "custom-class": "sk-dialog custom-fee-add-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.customFeeDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "custom-fee-dialog-header",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("i", {
                staticClass: "el-icon-circle-plus custom-fee-header-icon",
              }),
              _c("div", [
                _c("div", { staticClass: "custom-fee-header-title" }, [
                  _vm._v("Thêm Khoản Thu Mới Vào File Mẫu & Danh Mục"),
                ]),
                _c("div", { staticClass: "custom-fee-header-subtitle" }, [
                  _vm._v(
                    "Khoản thu này sẽ được lưu vào danh mục Sheet 'Khoản Thu' và hiển thị ở cuối Sheet 'Danh Sách HS'"
                  ),
                ]),
              ]),
            ]
          ),
          _c("div", { staticClass: "custom-fee-body" }, [
            _c(
              "div",
              {
                staticClass: "sk-panel",
                staticStyle: { background: "#f1f5f9", padding: "12px 14px" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "sk-panel-title",
                    staticStyle: {
                      "font-size": "13px",
                      "margin-bottom": "8px",
                    },
                  },
                  [
                    _c("i", { staticClass: "el-icon-lock" }),
                    _vm._v(
                      " Mã hệ thống tự động sinh (Cố định, không chỉnh sửa)\n        "
                    ),
                  ]
                ),
                _c("div", { staticStyle: { display: "flex", gap: "12px" } }, [
                  _c(
                    "div",
                    { staticStyle: { flex: "1" } },
                    [
                      _c("span", { staticClass: "custom-fee-label" }, [
                        _vm._v("Mã khoản thu (revenueCode ≤ 10 ký tự):"),
                      ]),
                      _c("el-input", {
                        attrs: {
                          disabled: "",
                          size: "small",
                          "prefix-icon": "el-icon-key",
                        },
                        model: {
                          value: _vm.customFeeForm.revenueCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.customFeeForm, "revenueCode", $$v)
                          },
                          expression: "customFeeForm.revenueCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { flex: "1.4" } },
                    [
                      _c("span", { staticClass: "custom-fee-label" }, [
                        _vm._v("Mã định danh hệ thống (idx ≤ 30 ký tự):"),
                      ]),
                      _c("el-input", {
                        attrs: {
                          disabled: "",
                          size: "small",
                          "prefix-icon": "el-icon-document",
                        },
                        model: {
                          value: _vm.customFeeForm.idx,
                          callback: function ($$v) {
                            _vm.$set(_vm.customFeeForm, "idx", $$v)
                          },
                          expression: "customFeeForm.idx",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "sk-panel",
                staticStyle: { "margin-top": "12px", padding: "12px 14px" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "sk-panel-title",
                    staticStyle: {
                      "font-size": "13px",
                      "margin-bottom": "8px",
                    },
                  },
                  [
                    _c("i", { staticClass: "el-icon-edit-outline" }),
                    _vm._v(" Thông tin cấu hình khoản thu\n        "),
                  ]
                ),
                _c(
                  "div",
                  { staticStyle: { "margin-bottom": "12px" } },
                  [
                    _c("span", { staticClass: "custom-fee-label" }, [
                      _vm._v("Tên khoản thu "),
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("*"),
                      ]),
                      _vm._v(":"),
                    ]),
                    _c("el-input", {
                      attrs: {
                        placeholder:
                          "Ví dụ: Phụ phí dã ngoại, Quỹ học phẩm, Đồng phục...",
                        size: "small",
                        clearable: "",
                      },
                      model: {
                        value: _vm.customFeeForm.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.customFeeForm, "name", $$v)
                        },
                        expression: "customFeeForm.name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      gap: "12px",
                      "margin-bottom": "12px",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { flex: "1" } },
                      [
                        _c("span", { staticClass: "custom-fee-label" }, [
                          _vm._v("Đơn vị tính:"),
                        ]),
                        _c("el-input", {
                          attrs: {
                            placeholder: "Buổi, Tháng, Lần, Chiếc...",
                            size: "small",
                          },
                          model: {
                            value: _vm.customFeeForm.unit,
                            callback: function ($$v) {
                              _vm.$set(_vm.customFeeForm, "unit", $$v)
                            },
                            expression: "customFeeForm.unit",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticStyle: { flex: "1" } },
                      [
                        _c("span", { staticClass: "custom-fee-label" }, [
                          _vm._v("Số lượng mặc định:"),
                        ]),
                        _c("el-input-number", {
                          staticStyle: { width: "100%" },
                          attrs: { step: 1, size: "small" },
                          model: {
                            value: _vm.customFeeForm.quantity,
                            callback: function ($$v) {
                              _vm.$set(_vm.customFeeForm, "quantity", $$v)
                            },
                            expression: "customFeeForm.quantity",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      gap: "12px",
                      "margin-bottom": "12px",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { flex: "1" } },
                      [
                        _c("span", { staticClass: "custom-fee-label" }, [
                          _vm._v("Đơn giá mặc định (đ):"),
                        ]),
                        _c("el-input-number", {
                          staticStyle: { width: "100%" },
                          attrs: { min: 0, step: 50000, size: "small" },
                          model: {
                            value: _vm.customFeeForm.price,
                            callback: function ($$v) {
                              _vm.$set(_vm.customFeeForm, "price", $$v)
                            },
                            expression: "customFeeForm.price",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticStyle: { flex: "1" } },
                      [
                        _c("span", { staticClass: "custom-fee-label" }, [
                          _vm._v("Giảm giá mặc định (đ):"),
                        ]),
                        _c("el-input-number", {
                          staticStyle: { width: "100%" },
                          attrs: { min: 0, step: 10000, size: "small" },
                          model: {
                            value: _vm.customFeeForm.discountNumber,
                            callback: function ($$v) {
                              _vm.$set(_vm.customFeeForm, "discountNumber", $$v)
                            },
                            expression: "customFeeForm.discountNumber",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _c("div", { staticClass: "custom-fee-calc-box" }, [
                  _c("div", { staticClass: "calc-box-left" }, [
                    _c("span", { staticClass: "calc-box-formula" }, [
                      _vm._v(
                        "\n              Công thức: " +
                          _vm._s(
                            _vm.customFeeForm.quantity !== undefined &&
                              _vm.customFeeForm.quantity !== null &&
                              _vm.customFeeForm.quantity !== ""
                              ? _vm.customFeeForm.quantity
                              : 1
                          ) +
                          " (SL) × " +
                          _vm._s(_vm.formatMoney(_vm.customFeeForm.price)) +
                          " (Đơn giá) − " +
                          _vm._s(
                            _vm.formatMoney(_vm.customFeeForm.discountNumber)
                          ) +
                          " (Giảm giá)\n            "
                      ),
                    ]),
                    _c("span", { staticClass: "calc-box-text" }, [
                      _vm._v("Thành tiền dự tính:"),
                    ]),
                  ]),
                  _c("div", { staticClass: "calc-box-amount" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.formatMoney(_vm.customFeeAmount)) +
                        " đ\n          "
                    ),
                  ]),
                ]),
              ]
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "sk-dialog__footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-cancel",
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.customFeeDialogVisible = false
                    },
                  },
                },
                [_vm._v("Hủy")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn-save",
                  attrs: { type: "success", icon: "el-icon-check" },
                  on: { click: _vm.confirmAddCustomFee },
                },
                [_vm._v("\n        Thêm vào danh mục\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "sk-dialog__footer wizard-footer-redesign",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _vm.activeStep === 0 &&
          (_vm.step1TemplateDataLoading ||
            _vm.studentLoading ||
            _vm.loadingBenchmark)
            ? _c(
                "div",
                {
                  staticClass: "wizard-source-data-status",
                  attrs: { role: "status", "aria-live": "polite" },
                },
                [
                  _c("i", { staticClass: "el-icon-loading" }),
                  _vm._v("\n      Đang lấy dữ liệu gốc, vui lòng chờ...\n    "),
                ]
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "footer-right" },
            [
              _vm.activeStep > 0
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn-wizard-prev",
                      attrs: {
                        size: "small",
                        icon: "el-icon-arrow-left",
                        plain: "",
                      },
                      on: { click: _vm.handlePrevStep },
                    },
                    [
                      _vm._v(
                        "\n        Quay lại Bước " +
                          _vm._s(_vm.activeStep) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.activeStep === 0
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn-wizard-next",
                      attrs: {
                        size: "small",
                        type: "primary",
                        loading:
                          _vm.step1TemplateDataLoading ||
                          _vm.studentLoading ||
                          _vm.loadingBenchmark,
                        disabled:
                          !_vm.step1TemplateDataReady ||
                          _vm.studentLoading ||
                          _vm.loadingBenchmark,
                      },
                      on: { click: _vm.handleNextStep1 },
                    },
                    [
                      _vm._v("\n        Tiếp tục sang Bước 2 "),
                      _c("i", { staticClass: "el-icon-arrow-right" }),
                    ]
                  )
                : _vm._e(),
              _vm.activeStep === 1
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn-wizard-next",
                      attrs: {
                        size: "small",
                        type: "primary",
                        loading: _vm.checkingOnlinePayment,
                        disabled:
                          !_vm.canProceedStep2 || _vm.checkingOnlinePayment,
                      },
                      on: { click: _vm.handleNextStep2 },
                    },
                    [
                      _vm._v("\n        Tiếp tục sang Bước 3 "),
                      _c("i", { staticClass: "el-icon-arrow-right" }),
                    ]
                  )
                : _vm._e(),
              _vm.activeStep === 2
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn-wizard-commit",
                      attrs: {
                        size: "small",
                        type: "success",
                        icon: "el-icon-check",
                        loading: _vm.savingInvoices,
                        disabled: _vm.savingInvoices,
                      },
                      on: { click: _vm.handleCommitInvoicesToBE },
                    },
                    [
                      _vm._v(
                        "\n        Khởi tạo phiếu thu vào hệ thống\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  staticClass: "btn-wizard-close",
                  attrs: { size: "small", plain: "", icon: "el-icon-close" },
                  on: { click: _vm.closeDialog },
                },
                [_vm._v("\n        Đóng\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }